import { useState, useEffect , useMemo} from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../Dashbaord/Layout.js/Layout';
import * as billApi from '../../../services/bills.services'; 
import {
     FaTrash, FaEye, FaUserPlus, FaSearch,
     FaEllipsisV, FaDownload,
    FaUsers, FaMoneyBill, FaEdit,
    FaCalendarAlt, FaBriefcase, FaFileInvoice,
    FaSync, FaExclamationTriangle,
    FaCheckCircle, FaClock, FaBan, FaReceipt
} from 'react-icons/fa';
import {
    Table, Container, Row, Col,
    Button, Badge, Dropdown,
    Form, InputGroup, Spinner, Alert,
    Card, Pagination, Modal, Toast, ToastContainer
} from 'react-bootstrap';
import { colors } from '../../../utils/Colors';

const AllBillsList = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState('');
    const [filterStatus, setFilterStatus] = useState('all');
    const [currentPage, setCurrentPage] = useState(1);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedBill, setSelectedBill] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState({ type: '', text: '' });
    const [refreshKey, setRefreshKey] = useState(0);
    const [startDate, setStartDate] = useState('');
const [endDate, setEndDate] = useState('');
    const itemsPerPage = 10;


    const [bills, setBills] = useState([]);
    const [stats, setStats] = useState({
        totalBills: 0,
        paidBills: 0,
        pendingBills: 0,
        totalRevenue: 0,
        confirmedBills: 0,
        cancelledBills: 0
    });

    const [searchInput, setSearchInput] = useState('');

   useEffect(() => {
        fetchBills();
    }, [filterStatus, refreshKey, currentPage, searchTerm]);

    const handleDateFilter = () => {
       
        setCurrentPage(1);
        
        setToastMessage({
            type: 'info',
            text: `Filtering bills from ${startDate} to ${endDate}`
        });
        setShowToast(true);
    };
// Function to clear date filter
const handleClearDateFilter = () => {
        setStartDate('');
        setEndDate('');
        setCurrentPage(1);
        
        setToastMessage({
            type: 'info',
            text: 'Date filter cleared'
        });
        setShowToast(true);
    };

     const fetchBills = async () => {
        try {
            setLoading(true);
            setError(null);
            
            const params = {};
            if (searchTerm) params.search = searchTerm;
            if (filterStatus !== 'all') params.status = filterStatus;
            params.page = currentPage;
            params.limit = itemsPerPage;
            
            // اگر تاریخ کے ساتھ فلٹر کرنا چاہیں تو API کو پارامس بھیجیں
            if (startDate && endDate) {
                params.startDate = startDate;
                params.endDate = endDate;
            }
            
            const response = await billApi.getAllBills(params);
            
            if (response.data && response.data.success) {
                const billsData = response.data.data || [];
                setBills(billsData);
                
                // اگر API سے stats آ رہے ہیں تو وہ استعمال کریں، ورنہ local calculate کریں
                setStats({
                    totalBills: response.data.stats?.totalBills || response.data.total || billsData.length,
                    paidBills: response.data.stats?.paidBills || billsData.filter(b => b.status === 'paid').length,
                    pendingBills: response.data.stats?.pendingBills || billsData.filter(b => b.status === 'pending').length,
                    totalRevenue: response.data.stats?.totalRevenue || billsData.reduce((sum, bill) => sum + (bill.billDetails?.totalAmount || 0), 0),
                    confirmedBills: response.data.stats?.confirmedBills || billsData.filter(b => b.status === 'confirmed').length,
                    cancelledBills: response.data.stats?.cancelledBills || billsData.filter(b => b.status === 'cancelled').length
                });
            } else {
                setBills([]);
                setStats({
                    totalBills: 0,
                    paidBills: 0,
                    pendingBills: 0,
                    totalRevenue: 0,
                    confirmedBills: 0,
                    cancelledBills: 0
                });
            }
        } catch (err) {
            console.error('Error fetching bills:', err);
            setError('Failed to load bills. Please try again.');
            setBills([]);
        } finally {
            setLoading(false);
        }
    };

   

    const handleSearch = () => {
        setSearchTerm(searchInput);
        setCurrentPage(1);
    };

    const handleDeleteBill = (bill) => {
        setSelectedBill(bill);
        setShowDeleteModal(true);
    };

    const handleEditBill = (billId) => {
        navigate(`/admin/dashboard/edit-bill/${billId}`);
    };

    const confirmDelete = async () => {
        if (!selectedBill) return;
        
        try {
            await billApi.deleteBill(selectedBill._id);
            
            setToastMessage({
                type: 'success',
                text: `Bill REF-${selectedBill.refNo} deleted successfully`
            });
            setShowToast(true);
            
            setRefreshKey(prev => prev + 1);
        } catch (err) {
            console.error('Error deleting bill:', err);
            setToastMessage({
                type: 'danger',
                text: 'Failed to delete bill. Please try again.'
            });
            setShowToast(true);
        } finally {
            setShowDeleteModal(false);
            setSelectedBill(null);
        }
    };

    const exportToCSV = async () => {
        try {
            const response = await billApi.getAllBills({ limit: 1000 });
            
            if (response.data && response.data.data) {
                const headers = [
                    'Ref No', 'Customer Name', 'CNIC', 'Event Date', 
                    'Day', 'Ladies', 'Gents', 'Venue', 'Total Amount', 
                    'Advance Paid', 'Persons', 'Service Type', 'Status', 
                    'Created At'
                ];
                
                const csvData = [
                    headers.join(','),
                    ...response.data.data.map(bill => [
                        bill.refNo || '',
                        `"${bill.eventDetails?.name || ''}"`,
                        bill.eventDetails?.cnic || '',
                        bill.eventDetails?.dateOfEvent || '',
                        bill.eventDetails?.dayOfEvent || '',
                        bill.eventDetails?.ladies || 0,
                        bill.eventDetails?.gents || 0,
                        `"${bill.eventDetails?.venue || ''}"`,
                        bill.billDetails?.totalAmount || 0,
                        bill.eventDetails?.advancePayment || 0,
                        bill.eventDetails?.persons || 0,
                        bill.serviceType || '',
                        bill.status || '',
                        bill.createdAt || ''
                    ].join(','))
                ].join('\n');
                
                const blob = new Blob([csvData], { type: 'text/csv' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `bills_export_${new Date().toISOString().split('T')[0]}.csv`;
                a.click();
                window.URL.revokeObjectURL(url);
                
                setToastMessage({
                    type: 'success',
                    text: 'Export completed successfully'
                });
                setShowToast(true);
            }
        } catch (err) {
            console.error('Error exporting bills:', err);
            setToastMessage({
                type: 'danger',
                text: 'Failed to export bills. Please try again.'
            });
            setShowToast(true);
        }
    };

    const handleRefresh = () => {
        setSearchInput('');
        setSearchTerm('');
        setFilterStatus('all');
        setCurrentPage(1);
        setRefreshKey(prev => prev + 1);
        setToastMessage({
            type: 'info',
            text: 'Refreshing bills list...'
        });
        setShowToast(true);
    };

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-PK', {
            style: 'currency',
            currency: 'PKR',
            maximumFractionDigits: 0
        }).format(amount || 0);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };

    const getStatusBadge = (status) => {
        const statusConfig = {
            'pending': { bg: 'warning', text: 'Pending', icon: <FaClock /> },
            'confirmed': { bg: 'info', text: 'Confirmed', icon: <FaCheckCircle /> },
            'paid': { bg: 'success', text: 'Paid', icon: <FaReceipt /> },
            'cancelled': { bg: 'danger', text: 'Cancelled', icon: <FaBan /> }
        };
        
        const config = statusConfig[status] || statusConfig.pending;
        
        return (
            <Badge bg={config.bg} className="px-3 py-2 d-flex align-items-center gap-2 justify-content-center">
                {config.icon}
                {config.text}
            </Badge>
        );
    };

   const filteredBills = useMemo(() => {
        return bills.filter(bill => {
            // Search filter
            const matchesSearch = 
                searchTerm === '' ||
                (bill.eventDetails?.name?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
                (bill.eventDetails?.cnic?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
                (bill.refNo?.toString() || '').includes(searchTerm);
            
            // Status filter
            const matchesStatus = filterStatus === 'all' || bill.status === filterStatus;
            
            // Date filter
            let matchesDate = true;
            if (startDate && endDate) {
                const billDate = new Date(bill.eventDetails?.dateOfEvent || bill.createdAt);
                const start = new Date(startDate);
                const end = new Date(endDate);
                end.setHours(23, 59, 59, 999);
                
                matchesDate = billDate >= start && billDate <= end;
            }
            
            return matchesSearch && matchesStatus && matchesDate;
        });
    }, [bills, searchTerm, filterStatus, startDate, endDate]);
 const totalPages = Math.ceil(filteredBills.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedBills = filteredBills.slice(startIndex, startIndex + itemsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handleFilterChange = (e) => {
        setFilterStatus(e.target.value);
        setCurrentPage(1);
    };

    return (
        <Layout>
            <ToastContainer position="top-end" className="p-3">
                <Toast 
                    show={showToast} 
                    onClose={() => setShowToast(false)} 
                    delay={3000} 
                    autohide
                    bg={toastMessage.type}
                >
                    <Toast.Header>
                        <strong className="me-auto">
                            {toastMessage.type === 'success' ? 'Success' : 
                             toastMessage.type === 'danger' ? 'Error' : 'Info'}
                        </strong>
                    </Toast.Header>
                    <Toast.Body className="text-white">
                        {toastMessage.text}
                    </Toast.Body>
                </Toast>
            </ToastContainer>

            <Container fluid className="p-3">
               
                <Row className="mb-4 align-items-center p-4 rounded-3" style={{ backgroundColor: colors.TABLE_HEADERS }}>
                    <Col md={6}>
                        <div>
                            <h2 className="fw-bold mb-2 text-white">Bills Management</h2>
                            <p className="text-white-50 mb-0">
                                <FaFileInvoice className="me-2" />
                                Manage all bills records and information
                            </p>
                        </div>
                    </Col>
        
                    <Col md={6} className="text-md-end">
                        <div className="d-flex gap-2 justify-content-md-end">
                            <Button
                                variant="outline-light"
                                onClick={handleRefresh}
                                className="d-flex align-items-center gap-2"
                            >
                                <FaSync />
                                Refresh
                            </Button>
                            <Button
                                variant="outline-light"
                                onClick={exportToCSV}
                                className="d-flex align-items-center gap-2"
                            >
                                <FaDownload />
                                Export
                            </Button>
                            <Button
                                variant="light"
                                onClick={() => navigate('/admin/dashboard/create-bill')}
                                className="d-flex align-items-center gap-2 px-4"
                            >
                                <FaUserPlus />
                                Create Bill
                            </Button>
                        </div>
                    </Col>
                </Row>

                
                {error && (
                    <Alert variant="danger" className="mb-4">
                        <FaExclamationTriangle className="me-2" />
                        {error}
                    </Alert>
                )}

               
                <Row className="mb-4">
                    <Col md={3}>
                        <Card className="border-primary">
                            <Card.Body>
                                <div className="d-flex justify-content-between align-items-center">
                                    <div>
                                        <h6 className="text-muted mb-1">Total Bills</h6>
                                        <h3 className="mb-0">{stats.totalBills}</h3>
                                    </div>
                                    <div className="rounded-circle p-3" style={{ backgroundColor: colors.TABLE_HEADERS }}>
                                        <FaFileInvoice className="text-white fs-4" />
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={3}>
                        <Card className="border-success">
                            <Card.Body>
                                <div className="d-flex justify-content-between align-items-center">
                                    <div>
                                        <h6 className="text-muted mb-1">Paid Bills</h6>
                                        <h3 className="mb-0">{stats.paidBills}</h3>
                                    </div>
                                    <div className="rounded-circle p-3" style={{ backgroundColor: colors.TABLE_HEADERS }}>
                                        <FaMoneyBill className="text-white fs-4" />
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={3}>
                        <Card className="border-warning">
                            <Card.Body>
                                <div className="d-flex justify-content-between align-items-center">
                                    <div>
                                        <h6 className="text-muted mb-1">Pending Bills</h6>
                                        <h3 className="mb-0">{stats.pendingBills}</h3>
                                    </div>
                                    <div className="rounded-circle p-3" style={{ backgroundColor: colors.TABLE_HEADERS }}>
                                        <FaCalendarAlt className="text-white fs-4" />
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={3}>
                        <Card className="border-info">
                            <Card.Body>
                                <div className="d-flex justify-content-between align-items-center">
                                    <div>
                                        <h6 className="text-muted mb-1">Total Revenue</h6>
                                        <h3 className="mb-0">
                                            {formatCurrency(stats.totalRevenue)}
                                        </h3>
                                    </div>
                                    <div className="rounded-circle p-3" style={{ backgroundColor: colors.TABLE_HEADERS }}>
                                        <FaBriefcase className="text-white fs-4" />
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

     <Card className="mb-4">
                <Card.Body>
                    <Row className="g-3">
                        <Col md={4}>
                            <InputGroup>
                                <InputGroup.Text style={{ backgroundColor: colors.TABLE_HEADERS, color: '#fff' }}>
                                    <FaSearch />
                                </InputGroup.Text>
                                <Form.Control
                                    placeholder="Search by bill no, customer name, or CNIC..."
                                    value={searchInput}
                                    onChange={(e) => setSearchInput(e.target.value)}
                                    onKeyPress={handleKeyPress}
                                    disabled={loading}
                                />
                                <Button 
                                    variant="outline-secondary"
                                    onClick={handleSearch}
                                    disabled={loading}
                                    style={{ 
                                        backgroundColor: colors.TABLE_HEADERS, 
                                        borderColor: colors.TABLE_HEADERS,
                                        color: '#fff'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#fff';
                                        e.target.style.color = colors.TABLE_HEADERS;
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = colors.TABLE_HEADERS;
                                        e.target.style.color = '#fff';
                                    }}
                                >
                                    <FaSearch className="me-2" />
                                    Search
                                </Button>
                            </InputGroup>
                        </Col>
                        <Col md={3}>
                            <Form.Control
                                type="date"
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                                disabled={loading}
                                style={{ borderColor: colors.TABLE_HEADERS }}
                            />
                        </Col>
                        <Col md={3}>
                            <InputGroup>
                                <Form.Control
                                    type="date"
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                    disabled={loading}
                                    min={startDate} // end date کو start date سے کم نہ ہونے دیں
                                    style={{ borderColor: colors.TABLE_HEADERS }}
                                />
                                <Button 
                                    variant="outline-secondary"
                                    onClick={handleDateFilter}
                                    disabled={loading || !startDate || !endDate}
                                    style={{ 
                                        backgroundColor: colors.TABLE_HEADERS, 
                                        borderColor: colors.TABLE_HEADERS,
                                        color: '#fff'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#fff';
                                        e.target.style.color = colors.TABLE_HEADERS;
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = colors.TABLE_HEADERS;
                                        e.target.style.color = '#fff';
                                    }}
                                >
                                    Filter
                                </Button>
                            </InputGroup>
                        </Col>
                        <Col md={2} className="text-end">
                            {loading && (
                                <Spinner animation="border" size="sm" className="me-2" style={{ color: colors.TABLE_HEADERS }} />
                            )}
                            <Dropdown>
                                <Dropdown.Toggle 
                                    variant="outline-secondary" 
                                    disabled={loading}
                                    style={{ borderColor: colors.TABLE_HEADERS, color: colors.TABLE_HEADERS }}
                                >
                                    <FaEllipsisV />
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={handleClearDateFilter}>
                                        Clear Date Filter
                                    </Dropdown.Item>
                                    <Dropdown.Divider />
                                    <Dropdown.Item onClick={handleRefresh}>
                                        <FaSync className="me-2" />
                                        Refresh Data
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </Col>
                    </Row>
                    
                </Card.Body>
            </Card>
              
                <Card>
                    <Card.Body>
                        {loading ? (
                            <div className="text-center py-5">
                                <Spinner animation="border" style={{ color: colors.TABLE_HEADERS }} />
                                <p className="mt-3">Loading bills...</p>
                            </div>
                        ) : paginatedBills.length > 0 ? (
                            <>
                                <div className="table-responsive">
                                    <Table hover className="align-middle">
                                        <thead>
                                            <tr>
                                                <th style={{ backgroundColor: colors.TABLE_HEADERS, color: '#fff', padding: '12px 16px', borderBottom: '2px solid #ddd' }}>Bill No</th>
                                                <th style={{ backgroundColor: colors.TABLE_HEADERS, color: '#fff', padding: '12px 16px', borderBottom: '2px solid #ddd' }}>Customer</th>
                                                <th style={{ backgroundColor: colors.TABLE_HEADERS, color: '#fff', padding: '12px 16px', borderBottom: '2px solid #ddd' }}>CNIC</th>
                                                <th style={{ backgroundColor: colors.TABLE_HEADERS, color: '#fff', padding: '12px 16px', borderBottom: '2px solid #ddd' }}>Event Date</th>
                                                <th style={{ backgroundColor: colors.TABLE_HEADERS, color: '#fff', padding: '12px 16px', borderBottom: '2px solid #ddd' }}>Total Amount</th>
                                                <th style={{ backgroundColor: colors.TABLE_HEADERS, color: '#fff', padding: '12px 16px', borderBottom: '2px solid #ddd' }}>Balance</th>
                                                <th style={{ backgroundColor: colors.TABLE_HEADERS, color: '#fff', padding: '12px 16px', borderBottom: '2px solid #ddd' }}>Status</th>
                                                <th style={{ backgroundColor: colors.TABLE_HEADERS, color: '#fff', padding: '12px 16px', borderBottom: '2px solid #ddd', width: '150px' }}>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {paginatedBills.map((bill) => (
                                                <tr key={bill._id}>
                                                    <td>
                                                        <strong>{bill.refNo}</strong>
                                                        <div className="small text-muted">
                                                            {bill.serviceType || 'Event'}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="fw-medium">{bill.eventDetails?.name || 'N/A'}</div>
                                                        <div className="small text-muted">
                                                            <FaUsers className="me-1" />
                                                            {bill.eventDetails?.persons || 0} Persons
                                                        </div>
                                                    </td>
                                                    <td>{bill.eventDetails?.cnic || 'N/A'}</td>
                                                    <td>
                                                        <div className="d-flex align-items-center">
                                                            <FaCalendarAlt className="me-2" style={{ color: colors.TABLE_HEADERS }} />
                                                            {bill.eventDetails?.dateOfEvent ? 
                                                                new Date(bill.eventDetails.dateOfEvent).toLocaleDateString() : 'N/A'
                                                            }
                                                        </div>
                                                    </td>
                                                    <td className="fw-bold" style={{ color: colors.TABLE_HEADERS }}>
                                                        {formatCurrency(bill.billDetails?.totalAmount || 0)}
                                                    </td>
                                                    <td>
                                                        <Badge 
                                                            className="px-3 py-2 fw-bold"
                                                            style={{ 
                                                                backgroundColor: (bill.billDetails?.totalAmount || 0) - (bill.eventDetails?.advancePayment || 0) > 0 
                                                                    ? '#fff3cd' 
                                                                    : '#d1e7dd',
                                                                color: (bill.billDetails?.totalAmount || 0) - (bill.eventDetails?.advancePayment || 0) > 0 
                                                                    ? '#856404' 
                                                                    : '#0f5132',
                                                                border: 'none'
                                                            }}
                                                        >
                                                            {formatCurrency(
                                                                (bill.billDetails?.totalAmount || 0) - (bill.eventDetails?.advancePayment || 0)
                                                            )}
                                                        </Badge>
                                                    </td>
                                                    <td>
                                                        {getStatusBadge(bill.status)}
                                                    </td>
                                                    <td>
                                                        <div className="d-flex gap-3 align-items-center">
                                                            <FaEye 
                                                                className="cursor-pointer" 
                                                                size={18}
                                                                onClick={() => navigate(`/admin/dashboard/view-bill/${bill._id}`)}
                                                                title="View Details"
                                                                style={{ 
                                                                    transition: 'all 0.2s',
                                                                    color: colors.TABLE_HEADERS 
                                                                }}
                                                                onMouseEnter={(e) => {
                                                                    e.target.style.transform = 'scale(1.2)';
                                                                    e.target.style.opacity = '0.8';
                                                                }}
                                                                onMouseLeave={(e) => {
                                                                    e.target.style.transform = 'scale(1)';
                                                                    e.target.style.opacity = '1';
                                                                }}
                                                            />
                                                            
                                                            <FaEdit 
                                                                className="cursor-pointer" 
                                                                size={18}
                                                                onClick={() => handleEditBill(bill._id)}
                                                                title="Edit Bill"
                                                                style={{ 
                                                                    transition: 'all 0.2s',
                                                                    color: '#0d6efd'
                                                                }}
                                                                onMouseEnter={(e) => {
                                                                    e.target.style.transform = 'scale(1.2)';
                                                                    e.target.style.opacity = '0.8';
                                                                }}
                                                                onMouseLeave={(e) => {
                                                                    e.target.style.transform = 'scale(1)';
                                                                    e.target.style.opacity = '1';
                                                                }}
                                                            />
                                                            
                                                            <FaTrash 
                                                                className="cursor-pointer" 
                                                                size={18}
                                                                onClick={() => handleDeleteBill(bill)}
                                                                title="Delete Bill"
                                                                style={{ 
                                                                    transition: 'all 0.2s',
                                                                    color: '#dc3545'
                                                                }}
                                                                onMouseEnter={(e) => {
                                                                    e.target.style.transform = 'scale(1.2)';
                                                                    e.target.style.opacity = '0.8';
                                                                }}
                                                                onMouseLeave={(e) => {
                                                                    e.target.style.transform = 'scale(1)';
                                                                    e.target.style.opacity = '1';
                                                                }}
                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>

                                {/* Pagination */}
                                {totalPages > 1 && (
                                    <div className="d-flex justify-content-between align-items-center mt-4">
                                        <div className="text-muted">
                                            Page {currentPage} of {totalPages}
                                        </div>
                                        <Pagination>
                                            <Pagination.Prev 
                                                onClick={() => currentPage > 1 && handlePageChange(currentPage - 1)}
                                                disabled={currentPage === 1}
                                            />
                                            {[...Array(totalPages)].map((_, index) => (
                                                <Pagination.Item
                                                    key={index + 1}
                                                    active={index + 1 === currentPage}
                                                    onClick={() => handlePageChange(index + 1)}
                                                    style={{
                                                        backgroundColor: index + 1 === currentPage ? colors.TABLE_HEADERS : '',
                                                        borderColor: colors.TABLE_HEADERS,
                                                        color: index + 1 === currentPage ? '#fff' : colors.TABLE_HEADERS
                                                    }}
                                                >
                                                    {index + 1}
                                                </Pagination.Item>
                                            ))}
                                            <Pagination.Next 
                                                onClick={() => currentPage < totalPages && handlePageChange(currentPage + 1)}
                                                disabled={currentPage === totalPages}
                                            />
                                        </Pagination>
                                    </div>
                                )}
                            </>
                        ) : (
                            <div className="text-center py-5">
                                <FaSearch className="fs-1 mb-3" style={{ color: colors.TABLE_HEADERS, opacity: 0.5 }} />
                                <h5>No bills found</h5>
                                <p className="text-muted">Try adjusting your search or filter criteria</p>
                                <Button 
                                    variant="primary"
                                    onClick={handleRefresh}
                                    style={{ backgroundColor: colors.TABLE_HEADERS, borderColor: colors.TABLE_HEADERS }}
                                >
                                    Reset Filters
                                </Button>
                            </div>
                        )}
                    </Card.Body>
                </Card>
            </Container>

            {/* Delete Confirmation Modal */}
            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Delete</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to delete bill <strong>REF-{selectedBill?.refNo}</strong> for {selectedBill?.eventDetails?.name}?
                    This action cannot be undone.
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
                        Cancel
                    </Button>
                    <Button 
                        variant="danger" 
                        onClick={confirmDelete} 
                        disabled={loading}
                        style={{ backgroundColor: '#dc3545', borderColor: '#dc3545' }}
                    >
                        {loading ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Deleting...
                            </>
                        ) : (
                            <>
                                <FaTrash className="me-2" />
                                Delete Bill
                            </>
                        )}
                    </Button>
                </Modal.Footer>
            </Modal>
        </Layout>
    );
};

export default AllBillsList;